export const FETCH_OPEN_TIME_ACTIVITIES_REQUEST = 'FETCH_OPEN_TIME_ACTIVITIES_REQUEST';
export const FETCH_OPEN_TIME_ACTIVITIES_FAILURE = 'FETCH_OPEN_TIME_ACTIVITIES_FAILURE';
export const FETCH_OPEN_TIME_ACTIVITIES_SUCCESS = 'FETCH_OPEN_TIME_ACTIVITIES_SUCCESS';
export const FETCH_BID_ANALYZER_REQUEST = 'FETCH_BID_ANALYZER_REQUEST';
export const FETCH_BID_ANALYZER_FAILURE = 'FETCH_BID_ANALYZER_FAILURE';
export const FETCH_BID_ANALYZER_SUCCESS = 'FETCH_BID_ANALYZER_SUCCESS';
export const CLEAR_FILTER_PAYLOAD = 'CLEAR_FILTER_PAYLOAD';
export const LAYOVER = 'LAYOVER';
export const ADD_OPEN_TIME_REQUEST_SUCCESS = 'ADD_OPEN_TIME_REQUEST_SUCCESS';
export const ADD_OPEN_TIME_REQUEST_FAILURE = 'ADD_OPEN_TIME_REQUEST_FAILURE';
export const UPDATE_OPEN_CONFIG_PAYLOAD = 'UPDATE_OPEN_CONFIG_PAYLOAD';
